import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";

// Sends logged-out visitors to sign-up, then back to the page they wanted.
export const RequireAccount = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) {
    return (
      <div data-testid="require-account-loading" className="min-h-screen flex items-center justify-center bg-brand-cream">
        <Loader2 className="h-6 w-6 animate-spin text-brand-teal" />
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/register" replace state={{ from: location.pathname + location.search, gate: "menu" }} />;
  }
  return children;
};
